<template>
  <div
    id="modal-drivers"
    ref="modal"
    tabindex="-1"
    role="dialog"
    class="modal fade"
    :class="{ 'hidden': !visible }"
    v-show="group && group.group && visible"
  >
    <div class="modal-dialog modal-fullwidth modal-maxheight">
      <div class="modal-content" v-if="group && group.group && visible">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>

          <h4
              v-if="selectedGroupsCount > 1"
              class="modal-title"
          >
            {{ selectedGroupsCount }} groepen inplannen
          </h4>

          <h4
              v-else
              class="modal-title"
          >
            Inplannen van “{{ group.group.name }}”
          </h4>
        </div>

        <div class="modal-body">
          <div class="row row__filters">
            <div class="col-lg-12">
              <plan-group-rides v-if="selectedGroupsCount <= 1" :group="group" style="display: inline-block;" />

              <div style="display: inline-block; width: 700px; float:right; padding-top: 10px;">
                <div class="col-lg-3 col-md-3" style="padding-top: 15px;">
                  <label class="custom-checkbox checkbox-secondary">
                    <input type="checkbox" class="driver-checkbox" id="availabilityByJobGroup" :value="jobIds.join(',')" v-model="activeFilters.availabilityByJobGroup">
                    <span class="label-text"></span>
                  </label>
                  <label for="availabilityByJobGroup">&nbsp; Beschikbaarheid</label>
                </div>

                <div class="col-lg-5 col-md-3">
                  <input type="text" class="form-control" v-model="activeFilters.search" placeholder="Zoeken..." />
                </div>

                <div class="col-lg-4 col-md-3" style="padding-right: 0;">
                  <availability-multiselect
                    :options="availabilities"
                    v-model="activeFilters.availabilities"
                    placeholder="Beschikbaarheid"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="false"
                    :preselect-first="false"
                    :taggable="false"
                    label="title"
                    track-by="name"
                  ></availability-multiselect>
                </div>
              </div>
            </div>
          </div>

          <div class="row m-top-20">
            <div class="col-xs-12">
              <div class="card card-fancy-table" style="box-shadow: none;">
                <div class="loaderui" v-bind:class="{ 'loaderui-loaded': loaded }">
                  <app-datatable
                    ref="appDatatable"
                    :data="driversFiltered"
                    :dragging="dragging"
                    :responsive="false"
                    :resizable="true"
                    :pagination="true"
                    :lazy-load="false"
                    :sticky="true"
                    :columns="columns"
                    @page="changePage"
                    @order="changeOrder"
                    @clicked-row="driverRowClicked"
                  >
                    <template v-slot:th-checkbox>
                      &nbsp;
                    </template>

                    <template v-slot:checkbox="{ row }">
                      <label class="custom-radio checkbox-secondary m-bottom-0 m-top-5">
                        <input type="radio" class="driver-checkbox" :value="row" v-model="selectedDriver">
                        <span class="label-text"></span>
                      </label>
                    </template>

                    <template v-slot:driver="{ row }">
                      <a :href="`profiel/${row.id}`" target="_blank">{{ row.name }}</a>
                    </template>

                    <template v-slot:time="{ row }">
                      <div v-if="row.availabilities" v-for="availability in row.availabilities">
                        <template v-if="availability.availability.name != 'unavailable'">
                          <span v-if="availability.available_all_day">
                              Hele dag
                          </span>
                          <span v-else>
                              {{ dateFormat(availability.available_from, 'HH:mm') }} -
                              {{ dateFormat(availability.available_to, 'HH:mm') }}
                          </span>
                        </template>
                      </div>
                    </template>

                    <template v-slot:availabilities="{ row }">
                      <div v-if="activeFilters.date">
                        <div  v-if="row.availabilities && row.availabilities.length && row.availabilities[0].availability">
                          <img :src="row.availabilities[0].availability.icon" data-toggle="tooltip" :title="row.availabilities[0].availability.title">
                          <i v-if="row.availabilities[0].changed" class="fa fa-exclamation-triangle" data-toggle="tooltip" title="Beschikbaarheid is aangepast na versturen notificatie"></i>
                        </div>
                        <div v-else>
                          <img src="/images/availabilities/unknown.svg">
                        </div>
                      </div>
                    </template>

                    <template v-slot:from_location="{ row }">
                      <div v-if="row.availabilities" v-for="availability in row.availabilities">
                        <template v-if="availability.availability.name != 'unavailable' && availability.from_location">
                          <template v-if="availability.from_location">
                            <div :class="{ 'text-danger': availability.from_location.city !== availability.to_location.city }">
                              {{ availability.from_location.city }}
                              <span v-if="availability.from_location.province_short">({{ availability.from_location.province_short }})</span><br>
                            </div>
                          </template>
                          <template v-else>
                            unknown
                          </template>
                        </template>
                      </div>
                    </template>

                    <template v-slot:to_location="{ row }">
                      <div v-if="row.availabilities" v-for="availability in row.availabilities">
                        <template v-if="availability.availability.name != 'unavailable' && availability.to_location">
                          <template v-if="availability.to_location">
                            <div :class="{ 'text-danger': availability.from_location.city !== availability.to_location.city }">
                              {{ availability.to_location.city }}
                              <span v-if="availability.to_location.province_short">({{ availability.to_location.province_short }})</span><br>
                            </div>
                          </template>
                          <template v-else>
                            unknown
                          </template>
                        </template>
                      </div>
                    </template>

                    <template v-slot:distance="{ row }">
                      {{ row.distance | formatDistance }} km
                    </template>

                    <template v-slot:comments="{ row, index }">
                      <div v-for="availability in row.availabilities">
                        <span v-if="availability.availability.name != 'unavailable'" data-toggle="tooltip" class="text-ellipse" style="display:block; width:150px" :data-placement="index > 3 ? 'top' : 'bottom'" :title="availability.comments">
                          {{ availability.comments }}
                        </span>
                      </div>
                    </template>

                    <template v-slot:note="{ row, index }">
                      <span class="text-ellipse" style="display:block; width:150px" data-toggle="tooltip" :data-placement="index > 2 ? 'top' : 'bottom'" :title="row.note">
                        {{ row.note }}
                      </span>
                    </template>

                    <template v-slot:noResults>
                      <span v-if="pageLoaded">Geen resultaten gevonden</span>
                      <span v-else><i class="fa fa-spin fa-spinner"></i> Bezig met laden...</span>
                    </template>

                  </app-datatable>

                  <div style="padding-right: 10px;" v-show="! pageLoaded && driversFiltered.length > 0" class="text-muted text-center">
                    <i class="fa fa-spin fa-spinner"></i> Meer laden...
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal Actions -->
        <div class="modal-footer text-left">
          <div class="row">
            <div class="col-md-4 col-md-offset-8">
              <div class="d-flex-a-center">
                <div style="width: 250px; margin-left: auto; margin-right: 10px; position: relative;">
                  <input type="time" class="form-control" :disabled="! selectedDriver" v-model="startTime">

                  <svg
                    :style="`background-color: ${selectedDriver ? '#fff' : '#eee'}`"
                    style="position: absolute; right: 10px; top: 12px; pointer-events: none"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    width="20"
                  ><path d="m12.938 13.396.77-.771-3.166-3.167V5H9.458v4.917ZM10 17.583q-1.562 0-2.948-.593-1.385-.594-2.417-1.625-1.031-1.032-1.625-2.417-.593-1.386-.593-2.948 0-1.583.593-2.969.594-1.385 1.625-2.406Q5.667 3.604 7.052 3.01 8.438 2.417 10 2.417q1.583 0 2.969.593 1.385.594 2.406 1.625 1.021 1.032 1.615 2.407.593 1.375.593 2.958 0 1.562-.593 2.948-.594 1.385-1.615 2.417-1.021 1.031-2.406 1.625-1.386.593-2.969.593ZM10 10Zm0 6.5q2.708 0 4.604-1.906T16.5 10q0-2.708-1.896-4.604T10 3.5q-2.688 0-4.594 1.896Q3.5 7.292 3.5 10q0 2.688 1.906 4.594Q7.312 16.5 10 16.5Z"/></svg>
                </div>

                <button id="submitBtn" type="button" class="btn btn-md btn-primary" :disabled="! selectedDriver" @click="$emit('selected', { driver_id: selectedDriver.id, time: startTime })">
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#FFFFFF"><g><rect fill="none" height="24" width="24"/></g><g><path d="M20,9V6h-2v3h-3v2h3v3h2v-3h3V9H20z M9,12c2.21,0,4-1.79,4-4c0-2.21-1.79-4-4-4S5,5.79,5,8C5,10.21,6.79,12,9,12z M9,6 c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2S7,9.1,7,8C7,6.9,7.9,6,9,6z M15.39,14.56C13.71,13.7,11.53,13,9,13c-2.53,0-4.71,0.7-6.39,1.56 C1.61,15.07,1,16.1,1,17.22V20h16v-2.78C17,16.1,16.39,15.07,15.39,14.56z M15,18H3v-0.78c0-0.38,0.2-0.72,0.52-0.88 C4.71,15.73,6.63,15,9,15c2.37,0,4.29,0.73,5.48,1.34C14.8,16.5,15,16.84,15,17.22V18z"/></g></svg>
                    Koppelen
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DriverModal',
  props: {
    date: {
      type: Object,
      default: null
    },

    group: {
      type: Object,
      default: null,
    },

    availabilities: {
      type: Array,
      required: true,
    },

    selectedGroupsCount: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      loaded: false,
      pageLoaded: false,
      dragging: false,
      loadThrothle: true,
      savingSettings: false,
      drivers: [],
      driver: null,
      columns: [
        {
          key: 'checkbox',
          name: 'Checkbox',
          center: true,
          show: true,
          sortable: false,
          width: 35,
        },
        {
          key: 'driver',
          name: 'Chauffeur',
          center: false,
          show: true,
          sortable: true
        },
        {
          key: 'age',
          name: 'Leeftijd',
          center: true,
          show: true,
          sortable: true,
          width: 60,
        },
        {
          key: 'rating',
          name: 'Cijfer',
          center: true,
          show: true,
          sortable: true,
          width: 60,
        },
        {
          key: 'availabilities',
          name: 'Beschikbaarheid',
          center: true,
          show: true,
          sortable: true,
          width: 140,
        },
        {
          key: 'time',
          name: 'Tijd',
          center: false,
          show: true,
          sortable: false,
          width: 150,
        },
        {
          key: 'from_location',
          name: 'Startlocatie',
          center: false,
          show: true,
          sortable: false,
          width: 150,
        },
        {
          key: 'to_location',
          name: 'Eindlocatie',
          center: false,
          show: true,
          sortable: false,
          width: 150,
        },
        {
          key: 'distance',
          name: 'Afstand',
          center: false,
          show: false,
          sortable: true,
          width: 150,
        },
        {
          key: 'comments',
          name: 'Reden beschikbaarheid',
          center: false,
          show: true,
          sortable: false,
          width: 150,
        },
        {
          key: 'note',
          name: 'Algemene notitie',
          center: false,
          show: true,
          sortable: false,
          width: 150,
        },

      ],
      selectedDriver: null,
      startTime: '08:00',
      activeFilters: {
        availabilities: [],
        search: '',
        date: this.date.format('YYYY-MM-DD'),
        availabilityByJobGroup: '',
        order: { name: 'ASC' },
      },
      page: 1,
      cache: [],
      visible: false,
      previousRequest: null,
    }
  },

  mounted() {
    this.init();

    window.addEventListener('keypress', this.submit, true);
  },

  beforeUnmount() {
    window.removeEventListener('keypress', this.submit, true);
  },

  watch: {
    activeFilters: {
      deep: true,
      handler() {
        if (this.loadThrothle) {
          this.page = 1;

          this.columns[8].show = this.activeFilters.availabilityByJobGroup;

          this.loadThrothle = false;
          setTimeout(() => {
            this.fetch(false, null, false, true);
            this.loadThrothle = true;
          }, 250)
        }
      }
    }
  },

  computed: {
    selectableAvailabilities() {
      return this.availabilities.filter((availability) => {
        return availability.name !== 'unknown';
      })
    },

    driversFiltered() {
      const driverData = this.drivers;
      if (driverData && driverData.data) {
        let noAvailbilityExists = false;
        if (this.activeFilters.availabilities.length > 0) {
          noAvailbilityExists = this.activeFilters.availabilities.filter(availability => {
            return availability.name === 'unknown';
          }).length > 0;
        }
        driverData.data = driverData.data.filter(driver => {
          if (this.activeFilters.date === null) {
            return true;
          }

          if (this.activeFilters.availabilities.length > 0) {
            if (noAvailbilityExists && driver.availability === null) {
              return true;
            }
            return this.activeFilters.availabilities
                .map(availability => availability.name)
                .includes(driver.availability);
          }

          return true;
        });

        return driverData;
      }

      return [];
    },

    jobIds() {
      return this.group.jobs.map(job => job.id);
    }
  },

  filters: {
    formatDistance: function (value) {
      if (!value) return '';
      return parseFloat(value).toFixed(2);
    }
  },

  methods: {
    init() {
      this.activeFilters.availabilities = this.availabilities.filter(availability => {
        return ['available', 'available.not-confirmed', 'available.not-asked'].includes(availability.name);
      });

      Echo.private('availabilities').listen('.user.availability.updated', (e) => {
          const data = this.drivers.data;

          if (data) {
            const driver = data.find((driver) => {
              return e.user_id === driver.id
            });

            if (driver) {
              this.fetchDriver(e.user_id);
            }
          }
        });
    },

    submit(event) {
      if (event.key === 'Enter' && this.visible) {
        event.preventDefault();

        const submitButton = document.getElementById('submitBtn');

        if (submitButton) {
          submitButton.click();
        }
      }
    },

    open() {
      this.visible = true;
      this.startTime = '08:00';
      this.activeFilters.order = { name: 'ASC' }
      this.activeFilters.search = '';
      this.activeFilters.availabilities = this.availabilities.filter(availability => {
        return ['available', 'available.not-confirmed', 'available.not-asked'].includes(availability.name);
      });

      if (this.previousRequest) {
        this.previousRequest.abort();
      }

      if (this.group.startdate) {
        this.startTime = moment(this.group.startdate).format('HH:mm');
      }

      this.fetch(false, null, false, true);


      jQuery(this.$refs.modal).modal().on('hidden.bs.modal', () => {
        this.visible = false;

        if (this.previousRequest) {
          this.previousRequest.abort();
        }

        this.$emit('close');
      });
    },

    fetch(pagination, callback, disableAutoRender, forceRefresh) {
      if (!this.visible) {
        return;
      }

      this.selectedDriver = null;
      this.pageLoaded = false;

      if (forceRefresh) {
        this.drivers = [];
      }

      const filters = {
        pagination: true,
        page: this.page,
        limit: 20,
        order: this.activeFilters.order,
        search: this.activeFilters.search,
        availabilities: this.activeFilters.availabilities.map((availability) => { return availability.name }),
        groupUuid: _.get(this.group, 'group.uuid', null),
      }

      if (this.activeFilters.availabilityByJobGroup) {
        filters.availabilityByJobGroup = this.activeFilters.availabilityByJobGroup;
      }

      if (this.activeFilters.date) {
        filters.date = this.date.format('DD-MM-YYYY')
      }

      const cacheKey = JSON.stringify(filters);
      if (cacheKey in this.cache) {
        this.pageLoaded = true;
        this.loaded = true;

        this.drivers = this.cache[cacheKey];
        return;
      }

      this.$http.get('/chauffeurs/ajax', {
        params: filters,
        before(request) {
          if (this.previousRequest) {
            this.previousRequest.abort();
          }
          this.previousRequest = request;
        }
      }).then((response) => {
        if (!disableAutoRender) {
          if (pagination && !forceRefresh) {
            const driversData = this.drivers.data ? this.drivers.data : [];
            const newData = response.data;
            newData.data = [...driversData, ...newData.data];
            this.drivers = newData;
          } else {
            this.drivers = response.data;
          }

          this.cache[`${cacheKey}`] = this.drivers;
        }

        this.loaded = true;
        this.pageLoaded = true;
        setTimeout(function () {
          $('[data-toggle="tooltip"]').tooltip();
        }, 100);
        if (callback) {
          callback(response.data);
        }
      });
    },

    fetchDriver(userId) {
      const filters = {
        pagination: false,
        drivers: [userId]
      }
      if (this.activeFilters.date) {
        filters.date = this.date.format('DD-MM-YYYY')
      }

      const driverIndex = this.drivers.data.findIndex((driver) => {
        return userId === driver.id
      });

      if (driverIndex !== undefined) {
        this.$http.get(`/chauffeurs/ajax`, {params: filters}).then((response) => {
          this.$set(this.drivers.data, driverIndex, response.data[0]);

          setTimeout(function () {
            $('[data-toggle="tooltip"]').tooltip();
          }, 100);
        });
      }
    },

    changePage(page) {
      this.page = page;
      this.selectedDriver = null;
      let selfChecked = this.$refs.appDatatable.$el.querySelector('.main-checkbox');
      if (selfChecked) {
        selfChecked.checked = false;
      }

      this.fetch(true);
    },

    changeOrder(order) {
      this.activeFilters.order = order;
    },

    driverRowClicked(row) {
      this.selectedDriver = row;
    },

    dateFormat(date, format) {
      date = moment(date);
      if (format) {
        date = date.format(format);
      }

      return date;
    },
  }
}
</script>

<style>
#modal-drivers .modal-header { background-color: #0088CC; padding: 15px 25px; }
#modal-drivers .modal-header .modal-title { color: #fff; }
#modal-drivers .card.card-fancy-table .table.table-bordered > thead > tr > th {
  background-color: white;
  z-index: 9;
}

#modal-drivers button.close { color: #fff; opacity: 1; }
#modal-drivers .table.table-bordered tbody tr {
  cursor: pointer;
}
#modal-drivers .card.card-fancy-table .table.table-bordered > tbody > tr > td, #modal-drivers .card.card-fancy-table .table.table-bordered > div > tr > td {
  border-top: 0;
  border-bottom: 0;
}

#modal-drivers .card.card-fancy-table, #modal-drivers  .card.card-fancy-table .loaderui { min-height: unset; }
#modal-drivers .card.card-fancy-table .table-sticky {
  min-height: unset;
  height: calc(100vh - 450px);
  overflow: auto;
  border: 1px solid #E1E1E1;
  border-radius: 8px;
}

#modal-drivers .multiselect__placeholder { color: #000 !important; }

#modal-drivers input[type=time].form-control {
  border-color: #D4D4D4;
  height: 45px;
  font-weight: bold;
}

#modal-drivers.modal .modal-content .modal-footer {
  padding-top: 0;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/plan/DriverModal.vue